module.exports = __webpack_public_path__ + "static/fonts/SCDream2.b183bda.otf";